import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import { getImagesByQuery } from './js/pixabay-api';
import {
  createGallery,
  clearGallery,
  showLoader,
  hideLoader,
  showLoadMoreBtn,
  hideLoadMoreBtn,
} from './js/render-functions';

const refs = {
  searchForm: document.querySelector('.form'),
  loadMoreBtn: document.querySelector('.load-more-btn'),
  gallery: document.querySelector('.gallery'),
};

let PER_PAGE = 15;
let TOTAL_HITS;
let page;
let query;

refs.searchForm.addEventListener('submit', async e => {
  e.preventDefault();
  const formData = new FormData(e.target);
  query = formData.get('search-text').trim();

  if (!query) {
    showErrorMessage('Please enter a search query.');
    return;
  }

  showLoader();

  hideLoadMoreBtn();
  clearGallery();

  page = 1;
  try {
    const results = await getImagesByQuery(query, page);
    const images = results.hits;
    TOTAL_HITS = Math.ceil(results.totalHits / PER_PAGE);
    if (images.length === 0) {
      showInfoMessage(
        'Sorry, there are no images matching your search query. Please try again!'
      );
    } else {
      createGallery(images);
      checkBtnStatus();
    }
  } catch (error) {
    showErrorMessage('Please try again later.');
    console.error(error);
  } finally {
    hideLoader();
  }

  refs.searchForm.reset();
});

refs.loadMoreBtn.addEventListener('click', async () => {
  page += 1;
  hideLoadMoreBtn();
  showLoader();
  try {
    const results = await getImagesByQuery(query, page);
    const images = results.hits;
    createGallery(images);
    scrollPage();
    checkBtnStatus();
  } catch (error) {
    showErrorMessage('Please try again later.');
    console.error(error);
  } finally {
    hideLoader();
	}
});

function showInfoMessage(message) {
  iziToast.info({
    title: 'Info',
    message: message,
    position: 'topRight',
    timeout: 3000,
  });
}

function showErrorMessage(message) {
  iziToast.error({
    title: 'Error',
    message: message,
    position: 'topRight',
    timeout: 3000,
  });
}

function checkBtnStatus() {
  if (page >= TOTAL_HITS) {
    hideLoadMoreBtn();
    showInfoMessage(
      "We're sorry, but you've reached the end of search results."
    );
  } else {
    showLoadMoreBtn();
  }
}

function scrollPage() {
  const elem = refs.gallery.lastElementChild;
  const height = elem.getBoundingClientRect().height;

  window.scrollBy({
    top: height * 2,
    behavior: 'smooth',
  });
}
